var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.group},[_c('div',{staticClass:"tabs"},[_vm._l((_vm.tabs),function(tab,index){return [_c('a',{key:`${_vm.group}-${index}`,staticClass:"tabs-title",class:{ selected: index === _vm.selectedTabIndex },on:{"click":function($event){return _vm.setSelectedTab(index)}}},[_vm._v(" "+_vm._s(tab.title)+" ")])]})],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }